import Vue from "vue";
const state = () => ({
  collections: [],
});

const mutations = {
  SET_LISTE_COLLECTIONS(state, payload) {
    state.collections = payload;
  },
};

const actions = {
  async getListeCollections({ commit }) {
    commit("Loading/START_BUSY_STATE", "Collection getListeCollections", { root: true });

    let collections = [];
    // ici Commence les requetes
    const GetAllCollections = await this._vm.$firebase
      .functions()
      .httpsCallable("getCollections");

    try {
      GetAllCollections().then((result) => {
        const dataItems = result.data.collections;
        dataItems.forEach((item) => {
          collections.push(item);
        });
      });
    } catch (err) {
      console.log("Error getting collection items", err);
    }

    commit("Loading/END_BUSY_STATE", "collection.store.js", { root: true });
    //Prennent fin les requestes

    commit("SET_LISTE_COLLECTIONS", collections);
  },
};

const getters = {
  collections: (state) => {
    return state.collections;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
